import { useEffect } from 'react';
import { useUpload } from '../../shared/context/UploadContext';
import { checkAndCleanupStaleUpload, UPLOAD_PENDING_STORAGE_KEY } from '../../services/uploadService';

/**
 * On mount, checks whether the current user has a stale upload session
 * (e.g. from a page refresh mid-upload) and marks it as failed if found.
 * Skipped entirely when no localStorage flag is present - avoids a Firestore
 * read on every page visit for users with no pending upload.
 * Also skipped for demo users and while an upload is actively in progress.
 * @param {import('firebase/auth').Auth} auth
 * @param {boolean} isDemo
 */
export function useStaleUploadCleanup(auth, isDemo) {
    const { isUploading } = useUpload();

    useEffect(() => {
        const uid = auth?.currentUser?.uid;
        if (isDemo || isUploading || !uid) return;
        if (!localStorage.getItem(UPLOAD_PENDING_STORAGE_KEY)) return;
        checkAndCleanupStaleUpload(uid).finally(() => {
            localStorage.removeItem(UPLOAD_PENDING_STORAGE_KEY);
        });
        // Intentionally mount-only: stale session detection runs once when the
        // grid first renders, not on every upload state change.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
